import { useResourceById } from "hooks/resources/useResourceById";
import { useParams } from "react-router-dom";
import { EntityViewModel } from "@common/entities/entity.model";
import { Flex, Spinner, Card, CardBody, Text, Grid } from "@chakra-ui/react";
import { Center } from "@chakra-ui/react";
import PageHeader from "components/layout/PageHeader";
import { useCustomFormats } from "hooks/useCustomFormat";
import LoansTable from "components/elements/LoansTable";
import WidgetBox from "components/elements/WidgetBox/widget-box";
import CompanyBorrowers from "pages/Company/CompanyBorrowers";
import { Properties } from "components/properties/properties";

export function Entity() {
    const { entityId } = useParams();
    const { data: entity } = useResourceById<EntityViewModel>(
        "Entities",
        entityId!
    );

    const { formatDate } = useCustomFormats();

    function Details({
        title,
        description,
    }: {
        title: string;
        description: string;
    }) {
        return (
            <Flex direction="column">
                <Text fontWeight={400} fontSize="14px" color="gray.200">
                    {title}
                </Text>
                <Text fontWeight={500} color="gray.900" fontSize="16px">
                    {description}
                </Text>
            </Flex>
        );
    }

    return (
        <>
            {!entity ? (
                <Center>
                    <Spinner />
                </Center>
            ) : (
                <Flex direction="column" gap={4}>
                    <PageHeader
                        title={entity.name}
                        breadcrumbs={[
                            {
                                title: "Borrowers",
                                to: "/borrowers",
                            },
                            {
                                title: entity.company.name,
                                to: `/companies/${entity.company.id}`,
                            },
                            {
                                title: entity.name,
                            },
                        ]}
                    />

                    <Card>
                        <CardBody>
                            <Flex justifyContent="space-between">
                                <Details
                                    title="Address"
                                    description={entity.address}
                                />
                                <Details
                                    title="Date Established"
                                    description={formatDate(
                                        entity.established_date
                                    )}
                                />
                                <Details
                                    title="Total Properties"
                                    description={"0"}
                                />
                                <Details
                                    title="Total Loans"
                                    description={"0"}
                                />
                            </Flex>
                        </CardBody>
                    </Card>

                    <Grid
                        templateColumns={{ md: "1fr", xl: "9fr 3fr" }}
                        gap={4}
                    >
                        <Flex direction="column" gap={4}>
                            <Properties
                                companyId={entity.company.id}
                                entityId={entity.id}
                            />
                            <WidgetBox title="Loans">
                                <LoansTable
                                    small
                                    borrower_company={entity.company.id}
                                    entity_id={entity.id}
                                    columns={[
                                        "Date",
                                        "Name",
                                        "Type",
                                        "Status",
                                        "Amount",
                                    ]}
                                />
                            </WidgetBox>
                        </Flex>
                        <CompanyBorrowers
                            company={entity.company.id}
                            entity={entity.id}
                            title="Contacts"
                            maxHeight="100%"
                        />
                    </Grid>
                </Flex>
            )}
        </>
    );
}
